export default __webpack_public_path__ + "static/media/intro_sm.9724ded7.png";